module.exports = __webpack_public_path__ + "static/media/gaas.d7cac599.mp3";